import React, { useEffect } from 'react'
import MainLayout from '../../../../layouts/MainLayout'
import BreadCrums from '../../../../components/BreadCrums'
import { useSelector } from 'react-redux'
import { getManagePolicyData } from '../../../../redux/actions/dashBoardActions'
import { useDispatch } from 'react-redux'
import { ImagePath } from '../../../../config/apiEndPoints'
import { useLocation } from 'react-router-dom'

function EmployeePaySlip() {
    const dispatch = useDispatch()
    const {state} = useLocation()
    const profileData = useSelector((state) => state.employeeData?.profile)
    // console.log(state,profileData?.company?.currency);
    
    return (
        <MainLayout>
            <div className="page-wrapper">
                <div className="content">
                    <BreadCrums
                        title={"Payslip"}
                        data={[
                            { path: "/admin/", title: "Admin" },
                            { path: "#", title: "Pay Slip" },
                        ]}
                        showButton={()=>{}}
                    />
                    <div className=" mb-2 p-4 border rounded shadow-sm payslip">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <img className="w-20 h-20 pb-1" src={profileData?.company?.company_logo ? ImagePath + profileData?.company?.company_logo
                                    : "/assets/img/logoNew.png"} alt="logo" />
                                {/* <img className="w-30 h-30 pb-1" src="/assets/img/logoNew.png" alt="logo" /> */}
                                <p className="text-muted mb-0">
                                    {profileData?.company?.company_address} ,{profileData?.company.state}({profileData?.company.pincode}),
                                </p>
                            </div>
                            <div className="text-end">
                                <p className="mb-0 fw-semibold">Payslip No <span className="text-primary">#{state?.salary_details?.payslip_no}</span></p>
                                <p className="mb-0 text-muted text-capitalize">Salary Month : <strong>{state?.salary_details?.month} {state?.salary_details?.year}</strong></p>
                            </div>
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <h5 className="fw-bold">From</h5>
                                <p className="fw-semibold mb-1">{profileData?.company?.company_name}</p>
                                <p className="mb-0 text-muted">
                                     {profileData?.company?.company_address} ,{profileData?.company.state}({profileData?.company.pincode}),
                                </p>
                                <p className="mb-0 text-muted">Email : {profileData?.company?.admin_email}</p>
                                <p className="mb-0 text-muted">Phone : <strong>{profileData?.company?.contact_no}</strong></p>
                            </div>
                            <div className="col-md-6 text-md-end text-end">
                                <h5 className="fw-bold">To</h5>
                                <p className="fw-semibold mb-1">{state?.employee?.name}</p>
                                <p className="mb-0 text-muted">{state?.employee?.designation}</p>
                                <p className="mb-0 text-muted">Email : {state?.employee?.email}</p>
                                <p className="mb-0 text-muted">Phone : <strong>{state?.employee?.mobile}</strong></p>
                            </div>
                        </div>

                        <div className="text-center mb-4">
                            <h6 className="fw-bold">Payslip for the moth of October 2024</h6>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="card p-3">
                                    <h6 className="fw-bold mb-3">Earnings</h6>
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>Basic Salary</span>
                                        <span>
                                         {profileData?.company?.currency||"₹"}{state?.salary_details?.basic_salary?.toFixed(2)}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>House Rent Allowance (H.R.A.)</span>
                                        <span>{profileData?.company?.currency||"₹"}{state?.salary_details?.hra?.toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Conveyance</span>
                                        <span>
                                          {profileData?.company?.currency||"₹"}{state?.salary_details?.special_allowance?.toFixed(2)}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between border-top mt-2 py-2">
                                        <b>Total Earnings</b>
                                        <span>
                                          {profileData?.company?.currency||"₹"}{state?.salary_details?.gross_salary?.toFixed(2) ||"0.00"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card p-3">
                                    <h6 className="fw-bold mb-3">Deductions</h6>
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>Tax Deducted at Source (T.D.S.)</span>
                                        <span>
                                          {profileData?.company?.currency||"₹"}{state?.salary_details?.tds?.toFixed(2)||0.00}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>Provident Fund</span>
                                        <span>
                                          {profileData?.company?.currency||"₹"}{state?.salary_details?.pf?.toFixed(2)||"0.00"}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span>Late</span>
                                        <span>
                                          {profileData?.company?.currency||"₹"}{state?.salary_details?.late_leave?.toFixed(2) ||"0.00"}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between border-top mt-2 py-2">
                                        <b>Total Deductions</b>
                                        <span>
                                          {profileData?.company?.currency||"₹"}{state?.salary_details?.total_deduction?.toFixed(2) ||"0.00"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='py-2'>
                            <p className=''>
                                Net Salary :<b >
                                   {profileData?.company?.currency||"₹"}{state?.salary_details?.net_salary?.toFixed(2)}
                                </b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

export default EmployeePaySlip
